export default class RoundSlider{

    #thumbEl
    #trackEl
    #displayValueEl
    #inputEl
    #value
    #min
    #max 
    #isDragging = false;
    #sliderWidth = 0
    #sliderHeight = 0
    #thumbWidth = 0

    #rafId = null;

    get value(){
        return this.#value
    }

    get input(){
        return this.#inputEl
    }

    get element(){
        return this.#trackEl
    }

    constructor(el,min=0,max=100){
        this.#max = el.hasAttribute('data-max') ? Number(el.getAttribute('data-max')) : max
        this.#min = el.hasAttribute('data-min') ? Number(el.getAttribute('data-min')) : min
        this.#inputEl = el.querySelector('.round-slider-input')
        this.#value = this.#inputEl.value ? Number(this.#inputEl.value) : this.#min
        this.#thumbEl = el.querySelector('.thumb')
        this.#trackEl = el
        this.#displayValueEl = el.querySelector('.value-display')
        window.addEventListener('resize', () => {
            this.updateDimensions();
        });


        // Обработчики событий
        this.#thumbEl.addEventListener('mousedown', () => {
            this.#isDragging = true;
            document.addEventListener('mousemove', this.#handleMouseMove.bind(this));
            document.addEventListener('mouseup', () => {
                this.#isDragging = false;
                document.removeEventListener('mousemove', this.#handleMouseMove.bind(this));
            });
        });

        this.#trackEl.addEventListener('click', (e) => {
            const rect = this.#trackEl.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            const percent = Math.max(0, Math.min(1, clickX / rect.width));
            const value = Math.round(percent * 50);
            this.updateSlider(value);
        });
        this.updateDimensions()
        this.updateSlider(this.#value)
    }

    updateSlider(value) {
        const normalized = Math.max(this.#min, Math.min(this.#max, value));
        const percent = (normalized / this.#max) * 100; 
        const left = (percent / 100) * (this.#sliderWidth - this.#thumbWidth - 6) + 3;
        this.#thumbEl.style.left = `${left}px`;
        const percentedRadiusTrack = (this.#sliderHeight/2) * (percent/100)
        const percentedRadiusThumb = (this.#thumbWidth/2) * (percent/100)
        this.#thumbEl.style.borderRadius = `${percentedRadiusThumb}px`;
        this.#trackEl.style.borderRadius = `${percentedRadiusTrack}px`;
        let prevValue = this.#value
        this.#value = value
        this.#inputEl.value = value
        if(typeof prevValue === 'number' && prevValue != value){
            let ev = new Event('change', {bubbles: true, cancelable: true});
            this.#inputEl.dispatchEvent(ev)
        }
        this.#displayValueEl.textContent = `${normalized}px`;
        if(percent<50){
            this.#displayValueEl.style.left="initial"
            this.#displayValueEl.style.right="1rem"
        }else{
            this.#displayValueEl.style.rigth="initial"
            this.#displayValueEl.style.left="1rem"
        }
    }

    #handleMouseMove(e) {
        if (!this.#isDragging) return;
        const rect = this.#trackEl.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const percent = Math.max(0, Math.min(1, clickX / rect.width));
        const value = Math.round(percent * this.#max);
        if (!this.#rafId) {
            this.#rafId = requestAnimationFrame(() => {
                this.updateSlider(value);
                this.#rafId = null;
            });
        }
    }

    updateDimensions() {
        const rectTrack = this.#trackEl.getBoundingClientRect();
        const rectThumb = this.#thumbEl.getBoundingClientRect();
        this.#sliderWidth = rectTrack.width;
        this.#sliderHeight = rectTrack.height;
        this.#thumbWidth = rectThumb.width;
        //console.log('SLIDER W:', this.#sliderWidth)
        //console.log('SLIDER H:', this.#sliderHeight)
    }
}
